import React, { useState } from "react";
import styles from "./RequestResetPassword.module.css";
import { useToasts } from "../LayoutComponents/ToastContext";
import i18n from "../Services/i18n";
import AccountService from "../Services/accountService";

const RequestResetPassword = () => {
  const { addToast } = useToasts();
  const [email, setEmail] = useState("");

  const submit = async () => {
    try {
      await AccountService.RequestChangePassword(email);
    } catch (error) {
      console.error("Email confirmation error:", error);
      addToast(
        i18n.t("ChangeEmailConfirmationPage.Error"),
        "GENERIC",
        "ERROR",
        true
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    submit();
  };

  return (
    <div className={styles.container}>
      <div className={styles.loginWrapper}>
        <form className={styles.loginForm} onSubmit={handleSubmit}>
          <p>{i18n.t("ChangePassword.RequestNewPasswordEmail")}</p>
          <label className={styles.loginLabel}>
            <input
              type="text"
              className={styles.loginInput}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>

          <div className={styles.loginFormFooter}>
            <button className={styles.loginButton} type="submit">
              {i18n.t("ChangePassword.RequestNewPasswordSubmitButton")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RequestResetPassword;
